// Çevrimdışı mod: IndexedDB anahtar-değer deposu + bağlantı durumu kancası
import { useEffect, useState } from 'react';

const DB = 'avm-offline';
const STORE = 'kv';

const open = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(DB, 1);
  req.onupgradeneeded = () => req.result.createObjectStore(STORE);
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

const tx = async (mode, fn) => {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => { db.close(); resolve(req?.result); };
    t.onerror = () => { db.close(); reject(t.error); };
  });
};

export const saveOffline = (key, value) => tx('readwrite', s => s.put(value, key)).catch(() => {});
export const loadOffline = (key) => tx('readonly', s => s.get(key)).catch(() => undefined);
export const clearOffline = () => tx('readwrite', s => s.clear()).catch(() => {});

export const useOnline = () => {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);
  return online;
};

// Onaylı (aktif, süresi dolmamış) talepleri detaylarıyla birlikte cihaza kaydeder
export const cacheApprovedPermits = (userId, permits, { companies, locations, allEmployees, allEquipment }, isActive) => {
  const items = permits.filter(isActive).map(p => ({
    permit: p,
    company: companies.find(c => c.id === p.company_id) || null,
    company_name: companies.find(c => c.id === p.company_id)?.name || '-',
    location_name: locations.find(l => l.id === p.location_id)?.name || '-',
    employees: allEmployees.filter(e => p.employee_ids?.includes(e.id)),
    equipment: allEquipment.filter(e => p.equipment_ids?.includes(e.id)),
  }));
  return saveOffline('approved-permits', { user_id: userId, saved_at: new Date().toISOString(), items });
};
